import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import NFSA_Date_Sale from './NFSA_Date_Sale';

const fetch_data = async (params) => {

    const response = await fetch(`${process.env.REACT_APP_URL_SALE}/NFSA_Sales_Int`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const NFSA_Sale = ({ month, year }) => {
    const [saleAllotedMonth, setSaleAllotedMonth] = useState(null);
    const [saleDistributionMonth, setSaleDistributionMonth] = useState([]);
    const [saleAbstractHeading, setsaleAbstractHeading] = useState(null);
    const [monthName, setmonthName] = useState(null);
    const [monthAbstractHeading, setmonthAbstractHeading] = useState(null);
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [renderContenttttt, setRenderContenttttt] = useState(null);
    const detailsRRef = useRef(null); // Use ref to scroll to this div
    const [renderContentt, setRenderContentt] = useState(null);

    const handleNfsaDistMonth = (month, year, trans_moth, trans_year) => {

        setRenderContenttttt(null);

        setTimeout(() => {
            setRenderContenttttt(
                <NFSA_Date_Sale
                    dist_month={month}
                    dist_year={year}
                    trans_moth={trans_moth}
                    trans_year={trans_year}
                />
            );
        }, 10);
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await fetch_data({ month, year });
                if (response_data && response_data.saleAllotedMonth) {
                    setSaleAllotedMonth(response_data.saleAllotedMonth);
                    setSaleDistributionMonth(response_data.saleDistributionMonth);
                    setsaleAbstractHeading(response_data.saleAbstractHeading);
                    setmonthName(response_data.monthName);
                    setmonthAbstractHeading(response_data.monthAbstractHeading);
                    setReportData(response_data.saleDistributionMonth);

                } else {
                    setsaleAbstractHeading(response_data.saleAbstractHeading);
                    setSaleAllotedMonth([]);
                    setSaleDistributionMonth([]);

                }
            } catch (err) {
                console.error("Error fetching data:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year]);

    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}><br /><br /><Box sx={{ display: 'flex' }}>
            <CircularProgress />
        </Box></div>
    }
    if (error) {
        return <div className="mainhead" align="center">
            Internal Error
        </div>
    }

    /*
        if (saleAllotedMonth == null && saleDistributionMonth == null ) {
            return <div class="mainhead" align="center">Details Not Found for Given FPS  </div>;
        }*/

    let saleAllotedMonth_comp;
    let saleDistributionMonth_comp;

    if (saleAllotedMonth == null && saleDistributionMonth == null) {
        return <div class="mainhead" align="center">{saleAbstractHeading}</div>;
    }

    if (!saleAllotedMonth || saleAllotedMonth === null || saleAllotedMonth.length == 0) {

        saleAllotedMonth_comp = <>
            <div class="mainhead" align="center">
                {saleAbstractHeading}
            </div>
        </>
    }
    else {

        saleAllotedMonth_comp = <>
            <table align="center" width="90%" border={1} >
                <thead>
                    <tr className="tableheader">
                        <th colSpan={8}>{saleAbstractHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <td>Allotted<br />Month/Year</td>
                        <td>Rice</td>
                        <td>FRice</td>
                        <td>Wheat</td>
                        <td>Atta</td>
                        <td>PMGKAY<br />Rice</td>
                        <td>PMGKAY<br />Wheat</td>
                        <td>PMGKAY<br />Dal</td>
                    </tr>
                </thead>
                <tbody>
                    {saleAllotedMonth.map((item, index) => (
                        <>
                            <tr key={index}>
                                <td style={{ textAlign: 'center' }}>
                                    {item.monthName} '{item.dist_year}</td>

                                <td style={{ textAlign: 'right' }}>{item.nfsa_rice.toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{item.nfsa_frice.toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{item.nfsa_wheat.toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{item.nfsa_atta.toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{item.pmgkay_rice.toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{item.pmgkay_wheat.toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{item.pmgkay_dal.toFixed(3)}</td>
                            </tr>
                        </>
                    ))}
                    <tr style={{ textAlign: 'right' }}>
                        <td colSpan="9">
                            <span style={{ color: 'red' }}>Refresh Time: </span>
                            <span style={{ color: 'green' }}>{saleAllotedMonth[0].data_time}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br>
            </br> <br></br>
        </>
    }


    const totals = reportData.reduce(
        (acc, item) => {
            acc.total_nfsa_rice += parseFloat(item.nfsa_rice) || 0;
            acc.total_nfsa_frice += parseFloat(item.nfsa_frice) || 0;
            acc.total_nfsa_wheat += parseFloat(item.nfsa_wheat) || 0;
            acc.total_nfsa_atta += parseFloat(item.nfsa_atta) || 0;
            acc.total_pmgkay_rice += parseFloat(item.pmgkay_rice) || 0;
            acc.total_pmgkay_wheat += parseFloat(item.pmgkay_wheat) || 0;
            acc.total_pmgkay_dal += parseFloat(item.pmgkay_dal) || 0;
            return acc;
        },
        {
            total_nfsa_rice: 0,
            total_nfsa_frice: 0,
            total_nfsa_wheat: 0,
            total_nfsa_atta: 0,
            total_pmgkay_rice: 0,
            total_pmgkay_wheat: 0,
            total_pmgkay_dal: 0

        }
    );

    if (!saleDistributionMonth || saleDistributionMonth.length == 0) {

        saleDistributionMonth_comp = <> </>
    } else {
        const lst = saleDistributionMonth[0]?.lst || [];
        saleDistributionMonth_comp = (
            <>
                <table align="center" width="90%" border={1} colSpan='8'>
                    <thead >
                        <tr className="tableheader">
                            <th colSpan={8}>{monthAbstractHeading}</th>
                        </tr>

                        <tr className="tableheader">
                            <td>Distribution<br />Month/Year</td>
                            <td>Rice</td>
                            <td>FRice</td>
                            <td>Wheat</td>
                            <td>Atta</td>
                            <td>PMGKAY<br />Rice</td>
                            <td>PMGKAY<br />Wheat</td>
                            <td>PMGKAY<br />Dal</td>
                        </tr>
                    </thead>
                    <tbody>
                        {saleDistributionMonth.map((item, index) => (
                            <>

                                <tr key={item.nfsa_atta || index}>
                                    <td style={{ textAlign: 'center' }}>
                                        <a
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={() => handleNfsaDistMonth(item.dist_month, item.dist_year, item.trans_moth, item.trans_year)}                                                                                >
                                            {item.monthName} '{item.trans_year}
                                        </a>
                                    </td>

                                    <td style={{ textAlign: 'right' }}>{item.nfsa_rice.toFixed(3)}</td>
                                    <td style={{ textAlign: 'right' }}>{item.nfsa_frice.toFixed(3)}</td>
                                    <td style={{ textAlign: 'right' }}>{item.nfsa_wheat.toFixed(3)}</td>
                                    <td style={{ textAlign: 'right' }}>{item.nfsa_atta.toFixed(3)}</td>
                                    <td style={{ textAlign: 'right' }}>{item.pmgkay_rice.toFixed(3)}</td>
                                    <td style={{ textAlign: 'right' }}>{item.pmgkay_wheat.toFixed(3)}</td>
                                    <td style={{ textAlign: 'right' }}>{item.pmgkay_dal.toFixed(3)}</td>

                                </tr>


                            </>
                        ))}
                    </tbody>

                    <tr className="tableheader">
                        <td style={{ textAlign: 'center', fontWeight: 'bold' }}>Total:</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_nfsa_rice.toFixed(3)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_nfsa_frice.toFixed(3)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_nfsa_wheat.toFixed(3)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_nfsa_atta.toFixed(3)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_pmgkay_rice.toFixed(3)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_pmgkay_wheat.toFixed(3)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_pmgkay_dal.toFixed(3)}</td>

                    </tr>
                    <tr style={{ textAlign: 'right' }}>
                        <td colSpan="9">
                            <span style={{ color: 'red' }}>Refresh Time: </span>
                            <span style={{ color: 'green' }}>{saleDistributionMonth[0].data_time}</span>

                        </td>
                    </tr>
                </table>
                <br />
                <br />
            </>
        );
    }

    return (

        <>
            {saleAllotedMonth_comp}
            {saleDistributionMonth_comp}

            {<div id="detailsERR" ref={detailsRRef}>{renderContenttttt}</div>}
        </>
    )
};

export default NFSA_Sale;

